<script>
  import Intro from "./Intro.svelte";
  import Capture from "./Capture.svelte";
  import Result from "./Result.svelte";

  const STATUS = {
    INTRO: 0,
    CAPTURE: 1,
    RESULT: 2,
  };
  let status = STATUS.INTRO;
  let image;

  const start = () => {
    status = STATUS.CAPTURE;
  };
  const capture = (imageData) => {
    image = imageData;
    status = STATUS.RESULT;
  };
</script>

<main>
  {#if status === STATUS.INTRO}
    <Intro {start} />
  {:else if status === STATUS.CAPTURE}
    <Capture {capture} />
  {:else}
    <Result {image} restart={start} />
  {/if}
</main>

<style>
  main {
    width: 100%;
    height: 100%;
    max-width: 100%;
    margin: 0;
    padding: 0;
    background-color: aliceblue;
  }
</style>
